import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

function LogoutModal({
  show,
  handleClose,
  handleLogout,
  type,
  name,
  handleDelete,
}) {
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="sm" 
        className="rtlByMe"
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ fontSize: "15px" }}>
            {type === "delete"
              ? `میخواهید این ${name} را حذف کنید؟`
              : "میخواهید خارج شوید؟"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            خیر
          </Button>
          <Button
            variant="primary"
            onClick={type === "delete" ? handleDelete : handleLogout}
          >
            بله
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default LogoutModal;
